import { StageEngagementTitle } from '@/engagements/StageEngagementTitle';
import { StageQR } from '@/routes/stage/StageQR';
import useWindowSize from '@/hooks/useWindowSize';
import {
  fitSlideFrame,
  SLIDE_QR_ZONE,
  slideFrameJoinOverlayStyle,
  slidePercentBoxStyle,
  slideQrPillMaxBox,
} from '../slideFrame';

export function FreeformStageJoinCta({
  muteJoin = false,
}: {
  muteJoin?: boolean;
}) {
  const { width, height } = useWindowSize();
  const frame = fitSlideFrame(width, height);

  return (
    <div
      data-name="STAGE_CHROME_SLIDE_QR"
      style={slideFrameJoinOverlayStyle(frame)}
    >
      <div
        data-name="STAGE_JOIN_CTA"
        data-muted={muteJoin ? 'true' : 'false'}
        className={muteJoin ? 'opacity-[0.38] grayscale' : 'opacity-100'}
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
      >
        <div
          data-name="STAGE_JOIN_PILL"
          style={{
            ...slidePercentBoxStyle(slideQrPillMaxBox()),
            overflow: 'visible',
            justifyContent: 'flex-end',
          }}
        >
          <StageEngagementTitle slideSize={frame} />
        </div>
        <div
          data-name="STAGE_JOIN_QR_CARD"
          style={slidePercentBoxStyle(SLIDE_QR_ZONE.card)}
        >
          <StageQR
            hideCta={muteJoin}
            mutedAppearance={muteJoin}
            slideSize={frame}
          />
        </div>
      </div>
    </div>
  );
}
